import { ref, onUnmounted } from 'vue'

export default function useSync() {
  const syncEnabled = ref(false)
  let eventHandlers = []

  function registerSync() {
    syncEnabled.value = true

    // Register tab synchronization listeners
    const handleStorageChange = event => {
      // Handle cross-tab synchronization
      if (event.key && event.newValue) {
        // Emit events to sync state across tabs
        console.info('Tab sync: Storage changed', event.key, event.newValue)
      }
    }

    const handleVisibilityChange = () => {
      // Handle tab visibility changes
      if (!document.hidden && syncEnabled.value) {
        // Sync state when tab becomes visible
        console.info('Tab sync: Tab became visible')
      }
    }

    window.addEventListener('storage', handleStorageChange)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    eventHandlers.push(
      () => window.removeEventListener('storage', handleStorageChange),
      () => document.removeEventListener('visibilitychange', handleVisibilityChange)
    )
  }

  function unregisterSync() {
    syncEnabled.value = false
    eventHandlers.forEach(cleanup => cleanup())
    eventHandlers = []
  }

  onUnmounted(() => {
    unregisterSync()
  })

  return {
    syncEnabled,
    registerSync,
    unregisterSync,
  }
}
